module.exports = __webpack_public_path__ + "d161e239bb4cce7103ee60de6ac779c2.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/icon-search.svg
// module id = ./app/images/icon-search.svg
// module chunks = 3